export default __webpack_public_path__ + "static/map-4b6645aef8e0f2f1ca2f9ac2f2aff97c.png";